import $ from 'jquery';

/**
 * Section: Side Cart
 * ------------------------------------------------------------------------------
 * Product form component.
 *
 * @namespace SideCart
 */

// Suppress Rebuy modal error
const observer = new MutationObserver(() => {
    const modal = document.querySelector('.rebuy-notification-modal.is-visible');
    const header = modal?.querySelector('.rebuy-notification-dialog-header');
    if (header?.textContent?.includes('updates parameter is invalid')) {
        modal.remove();
        if (document.querySelector('body').classList.contains('rebuy-modal-visible')) {
            document.querySelector('body').classList.remove('rebuy-modal-visible');
        }
    }
});

observer.observe(document.body, {childList: true, subtree: true});


class SideCart extends HTMLElement {
    constructor() {
        super();
        this.accessToken = '7ad3885b93ddd9c81fb8c0961eb7d591';
        this.graphUrl =
            'https://animalpak-production.myshopify.com/api/2022-10/graphql.json';
        this.progress = $(this).find('.progress');
        this.totalPrice = $(this).find('#side-cart__total-price');
        this.totalAmount = this.querySelector('.side-cart__amount');
        this.bundle = document.querySelector('bundle-page');
        this.cart = null;

        this.cart_recommended_products = $(this).find(
            '.side-cart .cart-recommended-products'
        )[0];
        this.renderCart();
        let self = this;

        this.recommendedProducts()

        const cartIconBubble = document.getElementById('cart-icon-bubble');
        cartIconBubble.addEventListener('click', function() {
          self.openCart();
        });
        
    }

    connectedCallback() {
        /**
         * Initialize onClick functions
         */
        this.addEventListener('click', (e) => {
            this.closeCart(e);
            this.subscribeButtonClick(e);
        });


        let cartChangeTimeout;

        document.addEventListener('rebuy:cart.change', (event) => {
            clearTimeout(cartChangeTimeout);
            cartChangeTimeout = setTimeout(() => {
                this.renderCart();
            }, 1000);
        });
    }

    openCart() {
        this.querySelector('.side-cart-wrap').classList.remove('!hidden');
        this.querySelector('.side-cart').classList.remove('hidden');
        document.querySelector('body').classList.add('cart-is-open');

        setTimeout(() => {
            this.querySelector('.side-cart').classList.add('active');
        }, 500);
    }

    /**
     * Closes the cart when clicking outside of it or on the close button
     */
    closeCart(e) {
        if (
            e.target.classList.contains('side-cart-wrap') ||
            e.target.classList.contains('close-side-cart')
        ) {
            this.querySelector('.side-cart').classList.remove('active');
            document.querySelector('body').classList.remove('cart-is-open');

            setTimeout(() => {
                this.querySelector('.side-cart-wrap').classList.add('!hidden');
                this.querySelector('.side-cart').classList.add('hidden');
            }, 300);
        }
    }


  async subscribeButtonClick(e) {
        let self = this;

        if (e.target.classList.contains('cart-item__subscribe--button')) {
            let productId = e.target.getAttribute('product-id');
            let sellingPlanId = e.target.getAttribute('data-selling-plan-id');
            let key = e.target.closest('.cart-item__subscribe').dataset.key;
            let quantity = document.getElementById(`quantity-${key}`).value;
            fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: key,
                    selling_plan: sellingPlanId,
                    quantity: quantity,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    self.renderCart();
                })
                .catch((error) => {
                    console.error('Error updating cart:', error);
                });
        }

       if (e.target.classList.contains('cart-bundle__subscribe--button')) {
            const idx = e.target.getAttribute('data-dynamic-box-index');
            const bid = e.target.getAttribute('data-dynamic-box-id');
          
            const rawPlanId = e.target.getAttribute('data-selling-plan-id');
            const sellingPlanId = rawPlanId ? Number(rawPlanId) : null; // null = unsubscribe
          
            const getCart = () => fetch('/cart.js').then(r => r.json());
          
            while (true) {
              const cart = await getCart();
              if (!cart?.items?.length) break;

          
              const next = cart.items.find(li => {
                const inBundle =
                  String(li.properties?._dynamicBoxIndex) === String(idx) &&
                  String(li.properties?._dynamicBoxId)    === String(bid);
          
                if (!inBundle) return false;
          
                if (li.properties?.giftItem) return false;
                if (li.properties?.isStackParent) return false;
                if (li.properties?.gear) return false; // your tag; adjust as needed
          
                const hasPlan = !!li.selling_plan_allocation;
                return sellingPlanId ? !hasPlan : hasPlan;
              });
          
              if (!next) break;
          
              const payload = {
                id: next.key,
                quantity: next.quantity,
                selling_plan: sellingPlanId,
              };
          
              const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              });
          
              if (!res.ok) {
                const text = await res.text().catch(() => '');
                console.warn('selling_plan change failed', { key: next.key, status: res.status, text });
                break;
              }
          
            }
          
            this.renderCart();
          }
          
    }
    

    itemTemplate(item, cart) {
        let price = item.discounted_price;
        let originalPrice = null;
        if (item?.selling_plan_allocation?.compare_at_price) {
            originalPrice = item?.selling_plan_allocation?.compare_at_price;
        }

        if (item.properties?._attribution_stack === 'Skio Stack') {
            item.properties.isStackProduct = true;
            item.properties.isBundleProduct = true;
            item.properties.subscription = !!item.selling_plan_allocation?.selling_plan?.id;
            item.properties.isStackParent = item.price === 0 ? true : false;
        }

        if (item.price > price) {
            originalPrice = item.price;
        }
        if (item.price < item.original_price) {
            originalPrice = item.original_price;
        }

        let displayBundleTag = false;

        //If the discount name has bundle in it, display the bundle tag
        if (item.properties?._attribution === 'Skio Dynamic Product Bundle') {
            displayBundleTag = true;
        } else {
            displayBundleTag = false;
        }

        const sessionTotals = {};

        cart.items.forEach(item => {
        const sessionId = item.properties?._bundle_session_id;
        if (!sessionId) return; // Skip items without a bundle session

        // Initialize the session totals object
        if (!sessionTotals[sessionId]) {
            sessionTotals[sessionId] = {
            originalTotal: 0,
            discountedTotal: 0
            };
        }

        const lineOriginalTotal = item.original_price * item.quantity; // Compare-at price
        const lineDiscountedTotal = item.final_line_price ?? item.price * item.quantity; 
        // `final_line_price` includes discounts in cart.js

        sessionTotals[sessionId].originalTotal += lineOriginalTotal;
        sessionTotals[sessionId].discountedTotal += lineDiscountedTotal;
        });

        const stackParent = item.properties?.isStackParent ? item : null;

        if (stackParent) {
            price = stackParent.properties.totalPrice;
            originalPrice = stackParent.properties.originalPrice;
        }

        if (item?.properties?.isStackParent) {
            price = sessionTotals[item.properties?._bundle_session_id].discountedTotal;
            originalPrice = sessionTotals[item.properties?._bundle_session_id].originalTotal;
        }

        let html = `<div data-stack-id="${item.properties?._bundle_session_id}" class="cart-item__wrap flex flex-col gap-4 ${!item.properties?.isStackParent && item.properties?.isStackProduct && item.price > 0 ? 'hidden' : ''}">`;

        html += `<div class="grid grid-cols-[max-content_1fr] relative ${
            item.properties?.giftItem && 'gift-item'
        }">

        <div class="cart-item__img relative flex justify-center items-center">
            <a href="${item.url}">
                <img src='${item.featured_image.url}' class="object-contain" />
            </a>
            <span class="hidden 
            ${displayBundleTag && 'bundle-tag'}">${
            displayBundleTag && 'Bundle'
        }</span>
        </div>
        <div class="ml-3 w-[calc(100%-95px)]">
            <a href="${
            item.url
        }" class="block cart-item__title text-primary uppercase font-bold">${
            item.product_title
        }</a>
            <div class="${
            !item.handle.includes('stack') && 'lg:flex flex-col'
        }">`;

        item.options_with_values.forEach(function (option) {
            html += `<div class="cart-item__option ${
                option.name == 'Title' && 'hidden'
            }">${option.name}: ${option.value}</div>`;
        });
        cart.items.forEach(function (stack) {
            if (
                stack.properties &&
                stack.properties?._bundle_session_id == item.properties?._bundle_session_id
            ) {
                if (
                    item.properties?.isStackParent &&
                    !stack.properties?.isStackParent
                ) {
                    html += `<div class="cart-item__option">1 x ${stack.product_title}${
                        stack.variant_title ? ' - ' + stack.variant_title : ''
                    }</div>`;
                }
            }
        });

        if (item.properties?.giftItem) {
            if (
                window.giftProducts.filter(
                    (product) => product.handle == item.handle
                )[0]?.variants?.length
            ) {
                let variants = window.giftProducts.filter(
                    (product) => product.handle == item.handle
                )[0]?.variants;

                let hideOptions =
                    variants?.length === 1 && variants[0].title === 'Default Title'
                        ? 'hidden'
                        : '';

                html += `<select class="cart-item__variants !ring-0 !outline-0 ${hideOptions}" data-key="${item.key}">`;
                variants?.forEach(function (variant) {
                    html += `<option ${
                        variant.id == item.id ? 'selected' : ''
                    } data-id="${variant.id}">${variant.title}</option>`;
                });

                html += `</select>`;
            }
        }

        const hasDyn =
        item.properties &&
        item.properties._dynamicBoxIndex != null && item.properties._dynamicBoxIndex !== '' &&
        item.properties._dynamicBoxId    != null && item.properties._dynamicBoxId    !== '';


        if (item.selling_plan_allocation?.selling_plan?.options[0]?.value) {
            html += `<span class="cart-item__subscription text-primary font-semibold mt-1 text-xs">Delivery frequency: <span class="font-light">${item.selling_plan_allocation?.selling_plan?.options[0]?.value}</span></span>`;
        }

        html += `<div class="cart-item__price mt-1 lg:mt-2 font-sans font-bold text-xs flex items-center text-primary">
            <span class="${
            !originalPrice || originalPrice == price ? 'hidden' : ''
        } mr-1 line-through opacity-50">${this.formatMoney(
            originalPrice
        )}</span>
            ${
            item.properties?.giftItem ? 'Free Gift' : this.formatMoney(price)
        } 
            <span class="hidden ${
            displayBundleTag && 'bundle-discount-text'
        }">${displayBundleTag && 'Bundle discount applied'}</span>
            </div>`;
        if (!item.properties?.giftItem) {
            html += `<div class="hidden lg:flex quantity-js">
                    
                    <quantity-input class="quantity cart-item__quantity
                    ${hasDyn ? 'hidden' : ''}
                    ${item.properties?._swell_discount_type || item.properties?._attribution === 'Rebuy Gift with Purchase' ? 'hidden' : ''}">
                    <button class="quantity__button cart-item__quantity-btn cart-item__adjust-qty no-js-hidden ${item.properties?.isStackParent && 'stack-quantity'}" name="minus" type="button">-</button>
                        <input class="quantity__input" type="number" name="quantity" id="quantity-${item.key}" min="1" ${item.properties?.['Gift id'] ? `data-product-with-gift="${item.properties?.['Gift id']}"`: ''} } value="${item.quantity}">
                        <button class="quantity__button cart-item__quantity-btn cart-item__adjust-qty no-js-hidden ${item.properties?.isStackParent && 'stack-quantity'}" 
                    ${item.properties?.['Gift product'] ? 'disabled' : ''} name="plus" type="button">+</button>
                    </quantity-input>


                    <button type="button" 
                    ${hasDyn ? `data-dynamic-box-index="${item.properties?._dynamicBoxIndex}" data-dynamic-box-id="${item.properties?._dynamicBoxId}"` : ''}
                    ${item.properties?.['Gift product'] ? 'disabled' : ''} id="remove-${item.key}" class="
                    ${item.properties?.isStackParent && 'hidden'} ${item.properties?.['Gift product']? 'pointer-events-none': ''} ${hasDyn ? 'bundle-item__remove' : ''} cart-item__remove cart-item__adjust-qty flex justify-center items-center uppercase font-bold font-sans text-primary cursor-pointer ${
                item.properties?._swell_discount_type ? 'hidden' : ''}">
                    remove
                    </button>
                    <button type="button" id="${item.properties?._bundle_session_id}" class="${!item.properties?.isStackParent && 'hidden'} stack-item__remove cart-item__adjust-qty flex justify-center items-center uppercase font-bold font-sans text-primary cursor-pointer">
                    remove
                    </button>
                    </div>`;
        }

        html += `</div></div>`;

        html += `</div>`;

        // If the product does not have a selling plan allocation, show the upgrade to subscription button based on the product's subscription availability
        if (!item.selling_plan_allocation && !item.properties?._hideSubs && !item.properties?._is_stack) {
            html += `<div class="cart-item__subscribe" data-key="${item.key}" data-stack-id="${item.properties?._}">`;
            // function to render the subscription button only if the product is available for subscription, this function makes a graphql API call to get the product's subscription availability
            this.renderSubscriptionButton(item.handle, item.id, item.properties?._attribution === 'Skio Dynamic Product Bundle', item.properties?._dynamicBoxIndex, item.properties?._dynamicBoxId, item.properties?._bundleSellingPlanId).then((button) => {
                this.querySelector(
                    `.cart-item__subscribe[data-key="${item.key}"]`
                ).innerHTML = button;
            });
            html += `</div>`;
        }
        html += `</div>`;

        

        return html;
    }

    changeVariant() {
        const self = this;

        document
            .querySelectorAll('.cart-item__variants')
            .forEach(function (select) {
                select.addEventListener('change', function () {
                    let id = this.options[this.selectedIndex].dataset.id;
                    let key = this.dataset.key;

                    $.post('/cart/update.js', `updates[${key}]=0`).done(function () {
                        let formData = {
                            items: [
                                {
                                    id,
                                    quantity: 1,
                                    properties: {
                                        giftItem: true,
                                    },
                                },
                            ],
                        };

                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(formData),
                        })
                            .then((response) => {
                                self.renderCart();
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                    });
                });
            });
    }

    renderSubscriptionButton(handle, id, isDynamicBundle, dynamicBoxIndex, dynamicBoxId, bundleSellingPlanId) {
        const self = this;
        return new Promise((resolve, reject) => {
            fetch(self.graphUrl, {
                async: true,
                crossDomain: true,
                method: 'POST',
                headers: {
                    'X-Shopify-Storefront-Access-Token': self.accessToken,
                    'Content-Type': 'application/graphql',
                },
                body: self.selectedProductQuery(handle),
            })
                .then((res) => res.json())
                .then((res) => {

                    let product = res.data.product;

                    if (product && product?.sellingPlanGroups?.edges?.length > 0) {
                        let skioEdge = product.sellingPlanGroups.edges.filter(
                            (edge) => edge.node.appName == 'SKIO'
                        );
                        
                        let sellingPlanId = isDynamicBundle ? 
                            Number(bundleSellingPlanId) : self.decodeId(
                            skioEdge[0]?.node?.sellingPlans.edges[0].node.id
                        );

                        let button = `
                        <button class="${isDynamicBundle ? 'cart-bundle__subscribe--button' : 'cart-item__subscribe--button'}  uppercase btn-secondary w-full ml-0 text-sm font-anton" product-id="${id}" data-selling-plan-id="${sellingPlanId}"
                        ${isDynamicBundle ? `data-dynamic-box-index="${dynamicBoxIndex}" data-dynamic-box-id="${dynamicBoxId}"` : ''}
                        >${isDynamicBundle ? 'Upgrade to subscription & save 5%' : 'Upgrade to subscription & save 15%'}</button>`;
                        resolve(button);
                    } 
                });
        });
    }

    

    renderCart() {
        let self = this;

        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
                self.cartWidget(cart);

                self.giftProducts(cart);

                $('.cart-items').empty();

                cart_items = [];
                cart_items_products_ids = {};

                cart.items.forEach(function (item) {
                    cart_items.push(String(item.id));
                    cart_items_products_ids[String(item.product_id)] = true;

                    if (!item.properties?.isStackProduct && !item.properties?.giftItem) {
                        $('.cart-items').append(self.itemTemplate(item, cart));
                    }
                });
                let giftItems = cart.items.filter((item) => item.properties?.giftItem);

                giftItems.sort(function (a, b) {
                    let titleA = a.title.toLowerCase();
                    let titleB = b.title.toLowerCase();
                    return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
                });

                giftItems.forEach(function (item) {
                    $('.cart-items').append(self.itemTemplate(item, cart));
                });

                self.changeVariant();

                //Update tier progress bar if enabled
                self.tieredProgressBar(cart);

                // cart total price
                let totalPrice = cart.items_subtotal_price;

                totalPrice = Math.ceil(totalPrice);
                self.totalPrice.text(self.formatMoney(totalPrice));

                $('.side-cart__clearpay').text(self.formatMoney(totalPrice / 4));

                // cart total amount
                self.totalAmount.innerHTML = `(${cart.item_count} items)`;

                //display empty cart state if no items in cart
                if (cart.item_count == 0) {
                    self.querySelector('.side-cart__empty').classList.remove('hidden');
                    self.querySelector('.cart-footer').classList.add('hidden');
                } else {
                    self.querySelector('.side-cart__empty').classList.add('hidden');
                    self.querySelector('.cart-footer').classList.remove('hidden');
                }

                //set cart count
                document.querySelector('.cart-count').innerText = cart.item_count;

                // adjust item quantity

                $('.cart-item__adjust-qty').on('click', function () {
                    if ($(this).hasClass('stack-quantity')) {
                        self.removeStack(this, cart, 'adjust');
                    } else if ($(this).hasClass('bundle-item__remove')) {
                        self.removeItemsWithSameDynamicBox($(this).data('dynamic-box-index'), $(this).data('dynamic-box-id'), cart, 'remove');
                    } else {
                        self.changeQuantity(this);
                    }
                });

                // checkout redirect
                self.checkoutRedirect(cart);

                $('.stack-item__remove').on('click', function () {
                    self.removeStack(this, cart, 'remove');
                });

                let recommendedProducts = document.querySelector(
                    'recommended-products-items-in-cart'
                );
                recommendedProducts?.createRecommendedProducts(cart_items);

                // remove gift
                if (
                    cart.items.length == 1 &&
                    cart.items[0].properties?.['Gift product']
                ) {
                    $.post('/cart/clear.js').then(() => {
                        self.renderCart();
                    });
                }

                self.cart = cart;
            },
        });
    }

    removeItemsWithSameDynamicBox(dynamicBoxIndex, dynamicBoxId, cart) {
        const self = this;
      
        if (!cart || !Array.isArray(cart.items)) return;
      
        const matches = cart.items.filter((li) =>
          String(li.properties?._dynamicBoxIndex) === String(dynamicBoxIndex) &&
          String(li.properties?._dynamicBoxId)    === String(dynamicBoxId)
        );
      
        if (!matches.length) return;


        const qty = 0
      
        const updates = {};
        matches.forEach((li) => { updates[li.key] = qty; });
      
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          contentType: 'application/json; charset=UTF-8',
          data: JSON.stringify({ updates }),
        }).always(() => self.renderCart?.());
      }
      

    tieredProgressBar(cart) {
        // Tier Progress Bar Updates
        const tierProgressBar = this.querySelector('.tiered-discount__bar');
        const tierProgressSteps = this.querySelectorAll('.tiered-discount__step');

        const subscriptionCount = cart.items.reduce((count, item) => {
            return item.selling_plan_allocation ? count + item.quantity : count;
        }, 0);

        switch (subscriptionCount) {
            case 0:
                tierProgressBar.style.width = '0%';
                // Clear all steps
                tierProgressSteps.forEach((element) => {
                    element.classList.remove('bg-yellow');
                });
                this.updateTierStatus(0);

                break;
            case 1:
                tierProgressBar.style.width = '25%';

                // Add 'bg-yellow' to the element with index="1" and clear the rest
                this.updateTierProgessSteps(1);
                this.updateTierStatus(1);
                break;
            case 2:
                tierProgressBar.style.width = '50%';

                this.updateTierProgessSteps(2);
                this.updateTierStatus(2);

                break;
            case 3:
                tierProgressBar.style.width = '75%';

                this.updateTierProgessSteps(3);
                this.updateTierStatus(3);
        }

        if (subscriptionCount >= 4) {
            tierProgressBar.style.width = '100%';
            this.updateTierProgessSteps(4);
            this.updateTierStatus(4);
        }
    }

    updateTierStatus(indexOfStep) {
        // tierStatus array loaded from the tiered-discount-bar.liquid snippet
        this.querySelector('.tiered-discount__status').innerHTML =
            tierStatus[indexOfStep];
    }

    updateTierProgessSteps(indexOfStep) {
        const tierProgressSteps = this.querySelectorAll('.tiered-discount__step');

        tierProgressSteps.forEach((element) => {
            // Get the index attribute value
            const index = parseInt(element.getAttribute('index'));
            if (index <= indexOfStep) {
                // Add the 'bg-yellow' class
                element.classList.add('bg-yellow');
            }
            // Check if the index is greater than 1
            if (index > indexOfStep) {
                // Remove the 'bg-yellow' class
                element.classList.remove('bg-yellow');
            }
        });
    }

    cartWidget(cart) {
        const self = this;

        $('.widget-title').text(
            cart.item_count == 0 ? 'recommended products' : 'ADD AN ITEM & SAVE'
        );

        return false;
    }

    giftProducts(cart) {
        const self = this;
        let products = window.giftProducts;

        if (!products || !products.length || !cart.items?.length) return;

        let addItems = [];
        let removeItems = [];
        let item_count = cart.items.filter(
            (item) => !item.properties?.giftItem
        ).length;
        products.forEach(function (gift) {
            if (gift.available) {
                let itemInCart = cart.items.filter(
                    (item) => item.handle == gift.handle && item.properties?.giftItem
                );

                let subPresent = cart.items.filter(
                    (item) =>
                        item.selling_plan_allocation &&
                        item.selling_plan_allocation.selling_plan.id
                );

                if (
                    cart.total_price / 100 >= gift.orderValue &&
                    !itemInCart.length &&
                    item_count > 0
                ) {
                    if (gift.subscription_only && subPresent.length) {
                        addItems.push(gift.id);
                    } else if (!gift.subscription_only) {
                        addItems.push(gift.id);
                    }
                }

                if (
                    cart.total_price / 100 < gift.orderValue &&
                    itemInCart.length &&
                    item_count > 0
                ) {
                    removeItems.push(
                        cart.items.filter(
                            (item) => item.handle == gift.handle && item.properties?.giftItem
                        )[0]?.key
                    );
                }

                if (item_count == 0 && itemInCart.length) {
                    removeItems.push(
                        cart.items.filter(
                            (item) => item.handle == gift.handle && item.properties?.giftItem
                        )[0]?.key
                    );
                }

                if (gift.subscription_only && subPresent.length <= 0) {
                    removeItems.push(
                        cart.items.filter(
                            (item) => item.handle == gift.handle && item.properties?.giftItem
                        )[0]?.key
                    );
                }
            }
        });

        cart.items.forEach(function (item) {
            if (
                item.properties?.giftItem &&
                !products.filter((product) => product.handle == item.handle).length
            ) {
                removeItems.push(item.key);
            }
        });
        const addGifts = async (data) => {
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: data,
                    }),
                });

                self.renderCart();
            } catch (error) {
            }
        };

        if (addItems.length) {
            let data = [];

            addItems.forEach(function (id) {
                data.push({
                    id: id,
                    quantity: 1,
                    properties: {
                        giftItem: true,
                    },
                });
            });

            addGifts(data);
            return;
        }

        // remove items
        if (removeItems.length) {
            let data;
            removeItems.forEach(function (key) {
                if (!data) {
                    data = `updates[${key}]=0`;
                } else {
                    data += `&updates[${key}]=0`;
                }
            });
            $.post('/cart/update.js', data).done(function () {
                self.renderCart();
            });
        }
    }

    checkoutRedirect(cart) {
        localStorage.removeItem('discount');

        $('.checkout-cta').attr('href', '/checkout');
    }

    changeQuantity(item) {
        let self = this;

        let input = $(item).closest('.quantity').find('.quantity__input'),
            quantity = input?.val() || 0,
            key =
                input?.attr('id')?.split('quantity-')[1] ||
                $(item).attr('id').split('remove-')[1];

        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: key,
                quantity: quantity,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                self.renderCart();

                document.dispatchEvent(new CustomEvent('cart:change', {
                    detail: data
                }));

            })
            .catch((error) => {
                console.error('Error updating cart:', error);
            });
    }

    formatMoney(price) {
        return (price / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    removeStack(item, cart, action) {
        const self = this;

        let id =
                $(item).attr('id') ||
                $(item)
                    .closest('.cart-item__wrap')
                    .find('.stack-item__remove')
                    .attr('id'),
            data,
            quantity =
                action == 'remove'
                    ? 0
                    : $(item).closest('.quantity').find('.quantity__input').val();


        function getCart(id) {
            let arr = [],
                data = '';

            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function (cart) {
                    cart.items.forEach(function (item) {
                        if (item.properties?._bundle_session_id == id) {
                            arr.push(item.key);
                        }
                    });

                    if (arr.length) {
                        arr.forEach(function (key, i) {
                            if (i == 0) {
                                data = `updates[${key}]=0`;
                            } else {
                                data += `&updates[${key}]=0`;
                            }
                        });

                        $.post('/cart/update.js', data).done(function () {
                            getCart(id);
                        });
                    } else {
                        self.renderCart();
                    }
                },
            });
        }

        cart.items.forEach(function (item) {
            if (item.properties?._bundle_session_id == id) {
                if (!data) {
                    data = `updates[${item.key}]=${quantity}`;
                } else {
                    data += `&updates[${item.key}]=${quantity}`;
                }
            }
        });
        $.post('/cart/update.js', data).done(function () {
            if (quantity) {
                self.renderCart();
            } else {
                getCart(id);
            }
        });
    }

    selectedProductQuery(handle) {
        return `query {
                product(handle: "${handle}") {
                    handle
                    title
                    productType
                    tags
                    metafield(key:"short_description_extra" namespace:"custom") {
                        value
                    }
                    featuredImage {
                        url
                    }
                    sellingPlanGroups(first: 10) {
                        edges {
                            node {
                                appName
                                sellingPlans(first: 10) {
                                    edges {
                                        node {
                                            id
                                            name
                                        }
                                    }
                                }
                            }
                        }
                    }
                    variants(first: 100) {
                        edges {
                            node {
                                id
                                price{
                                    amount
                                }
                                title
                                availableForSale
                                quantityAvailable
                                metafield(key: "variant_color", namespace: "custom") {
                                  value
                                }
                            }
                        }
                    }
                    options {
                        name
                        values
                    }
                }
            }`
    }

    selectedProductDrawer(product) {
        const self = this

        let html = `<div class="cart-selected_product__drawer">
                <div class="selected_product__drawer-inner bg-white relative">
                <div class="close-product__drawer selected_product__drawer-mobile"></div>
                <div class="absolute close-product__drawer cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="pointer-events-none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17" style="width: 20px;">
                        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="black"></path>
                    </svg>
                </div>
                <div class="bg-white relative selected_product__drawer-mobile-inner">
                
                <div class="lg:flex items-center">
                    <img src="${
            product.featuredImage?.url
        }" class="selected_product__img object-contain" /> 
                    <div>
                        <div class="selected_product__title uppercase text-primary font-bold">${
            product.title
        }</div>
                        <div class="selected_product__type mt-1 font-sans text-primary">${
            product.productType
        }</div>
                        <div class="selected_product__price mt-1 font-sans text-primary">$${
            product.variants.edges[0].node.price.amount
        }</div>
                    </div>
                </div>
                <div class="cart-purchase-type hidden mt-4 ${
            !product.sellingPlanGroups.edges.length && '!hidden'
        }">
                    <div class="flex items-center">
                        <input type="radio" name="cart-purchase" id="cart-subscribe" class="hidden cursor-pointer" value="subscribe">
                        <label for="cart-subscribe"
                            class="relative flex items-center text-[13.91px] text-primary capitalize font-sans font-semibold leading-[22.26px] cursor-pointer">Subscribe
                            & save</label>
                    </div>
                    <select class="${
            !product.sellingPlanGroups?.edges.length && '!hidden'
        } hidden select__select text-[13.9px] mt-3 mb-3 block pl-3 pr-10 py-2 text-base focus:outline-none focus:ring-0  h-[56px] border border-solid border-[#DBDBDB]">`

        if (product.sellingPlanGroups?.edges) {
            let skioEdge = product.sellingPlanGroups.edges.filter(
                (edge) => edge.node.appName == 'SKIO'
            )
            skioEdge[0]?.node?.sellingPlans?.edges.forEach(function (plan) {
                html += `<option data-id="${self.decodeId(plan.node.id)}">${
                    plan.node.name
                }</option>`
            })
        }

        html += `</select>
                    <div class="flex items-center mt-1">
                        <input type="radio" name="cart-purchase" id="cart-one-time" class="hidden cursor-pointer" checked value="one-time">
                        <label for="cart-one-time"
                            class="relative flex items-center text-[13.91px] text-primary capitalize font-sans font-semibold leading-[22.26px] cursor-pointer">One-time
                            purchase</label>
                    </div>
                </div>
                <div class="lg:flex lg:space-x-4 mt-6 mb-[18px]">`

        product.options.forEach(function (option) {
            if (option.name !== 'Title') {
                html += `<div class="product-form__input product-form__input--dropdown w-full lg:w-6/12">
            <div class="product-select"> 
              <div class="cart-custom-select-block custom-select-arrow relative">
                <select name="options-${option.name}"
                  class="option_select select__select  mt-2 lg:mt-1 block w-full pl-3 pr-10 py-2 text-base focus:outline-none focus:ring-0 h-[56px] border border-solid border-[#DBDBDB]">
                  <option value="" selected disabled hidden>
                  Choose ${option.name}
                  </option>`

                option.values.forEach(function (value) {
                    // Find the corresponding variant based on the value
                    const variant = product.variants.edges.find(
                        (edge) => edge.node.title === value
                    )

                    // Check if the variant has a metafield
                    const metafieldValue = variant?.node?.metafield?.value || '#fff'

                    html += `<option value="${value}" data-color="${metafieldValue}">
              <span class="color-circle"></span>
              ${value}
            </option>`
                })

                html += `   </select>
              </div>
            </div>
          </div>`
            }
        })

        html += `</div>
                <div class="flex mt-4">
                    <button class="block cart-item_submit tracking-[1px] w-full border border-solid border-yellow hover:bg-white hover:border-primary transition duration-500 bg-yellow uppercase w-full text-center py-[18px] transition duration-500 text-primary text-[13.9px] font-sans font-bold leading-[18.07px] ${
            product.variants.edges.length > 1 && 'disabled'
        }" >${
            product.variants.edges.length > 1
                ? 'make selection'
                : 'add'
        }</button>
                </div>
                </div>
                </div>
            </div>`

        return html
    }

    generateCustomSelect() {
        const selects = document.querySelectorAll('select[name="options-Flavor"]')
        selects.forEach(function (select) {
            // Create the custom select element
            const customSelect = document.createElement('div')
            customSelect.classList.add('cart-custom-select')

            // Create the selected value div
            const selectedValue = document.createElement('div')
            selectedValue.classList.add('selected-value')
            selectedValue.textContent =
                select.options[select.selectedIndex].textContent

            // Create the color circle span for the selected option
            const colorCircle = document.createElement('span')
            colorCircle.classList.add('color-circle')
            // Set the background color of the color circle to the data-color attribute of the selected option
            colorCircle.style.backgroundColor =
                select.options[select.selectedIndex].getAttribute('data-color')
            selectedValue.appendChild(colorCircle)

            // Append the selected value div to the custom select
            customSelect.appendChild(selectedValue)

            const optionsList = document.createElement('ul')
            // Add the options-list class to the optionsList element
            optionsList.classList.add('options-list')

            for (let i = 0; i < select.options.length; i++) {
                // Loop through each option in the select element
                const option = select.options[i]
                if (option.value !== '') {
                    // Exclude the "Choose Flavor" option
                    const optionItem = document.createElement('li')

                    // Set the background color of the color circle to the data-color attribute of the option
                    const colorCircle = document.createElement('span')
                    colorCircle.classList.add('color-circle')
                    colorCircle.style.backgroundColor = option.getAttribute('data-color')
                    // Append the colorCircle element to the optionItem
                    optionItem.appendChild(colorCircle)

                    // Set the text content of the optionText element to the trimmed text content of the option
                    const optionText = document.createElement('span')
                    optionText.textContent = option.textContent.trim()
                    optionItem.appendChild(optionText)

                    optionItem.addEventListener('click', function () {
                        const clickedOption = option

                        selectedValue.textContent = clickedOption.textContent

                        // Remove the existing colorCircle element
                        const existingColorCircle =
                            selectedValue.querySelector('.color-circle')
                        if (existingColorCircle) {
                            selectedValue.removeChild(existingColorCircle)
                        }

                        // Set the background color of the color circle to the data-color attribute of the clicked option
                        const newColorCircle = document.createElement('span')
                        newColorCircle.classList.add('color-circle')
                        newColorCircle.style.backgroundColor =
                            clickedOption.getAttribute('data-color')
                        selectedValue.appendChild(newColorCircle)

                        select.selectedIndex = i
                        customSelect.classList.remove('open')

                        // Manually trigger the change event on the original select element
                        const changeEvent = new Event('change', {bubbles: true})
                        select.dispatchEvent(changeEvent)
                    })

                    optionsList.appendChild(optionItem)
                }
            }

            // Append the optionsList to the custom select
            customSelect.appendChild(optionsList)

            selectedValue.addEventListener('click', function () {
                // Toggle the open class on the custom select
                customSelect.classList.toggle('open')
            })

            // Insert the custom select before the original select
            select.parentNode.insertBefore(customSelect, select)

            // Hide the original select
            select.style.display = 'none'
        })
    }

    decodeId(id) {
        // const decoded = atob(id)
        const shopifyId = id.split('/').pop()
        return parseInt(shopifyId)
    }

    createRecommendedProducts() {
        const self = this

        //Quite if we don't have Algolia data for recommendation
        if (algolia_recommendation_data === false) {
            return false
        }

        //Check if we have anyting in cart
        if (cart_items.length == 0) {
            //We don't have anything in the cart - hide block
            this.cart_recommended_products.classList.add('hidden')
            return false
        } else {
            //We have someting in the cart - show block
            this.cart_recommended_products.classList.remove('hidden')
        }

        const recommendClient = recommend(
            // Initialize the Algolia Recommend client
            algoliaShopify.config.app_id,
            algoliaShopify.config.search_api_key
        )

        const indexName = algolia_recommendation_data.index_name

        // Initialize the frequentlyBoughtTogether component
        frequentlyBoughtTogether({
            container: '#frequentlyBoughtTogether',
            recommendClient,
            indexName,
            objectIDs: cart_items,
            maxRecommendations: algolia_recommendation_data.limit * 3,

            transformItems(items) {
                // Delete repeated products + Delete product that are already in the cart
                let showed_products = []
                let counter = 0

                let result = items.filter((item) => {
                    if (
                        // Check if we already showed this product
                        showed_products[item.id] ||
                        counter >= algolia_recommendation_data.limit ||
                        cart_items_products_ids[item.id] ||
                        item.price == 0
                    ) {
                        return false
                    }
                    // Mark product as showed
                    showed_products[item.id] = true
                    counter++
                    return true
                })

                // Check if we have any recommended products
                if (result.length == 0) {
                    // there is no any recommended products - hide element
                    self.cart_recommended_products.classList.add('hidden')
                } else {
                    self.cart_recommended_products.classList.remove('hidden')
                }

                return result
            },

            itemComponent({item, html}) {
                // Create the item component
                return html`
                    <div
                            style="width:270px; height:115px;padding:10px; border-radius:8px"
                            class="flex items-center bg-[#F5F5F5]"
                    >
                        <div style="flex-shrink:0; width:95px; height:95px" class=" p-2 ">
                            <img
                                    src="${item.product_image}"
                                    class="w-full h-full object-contain"
                            />
                        </div>
                        <div style="flex-direction:column;gap:10px;" class="flex ml-4 w-full">
                            <div
                                    style="font-family:'Familjen Grotesk'"
                                    class="fbt-title text-[14px] lg:text-[14px] capitalize font-bold leading-[14.72px] lg:leading-[19.46px]"
                            >
                                ${item.title}
                            </div>
                            <div class="text-primary text-[16px] lg:text-[16px]">
                                    $${item.price}
                            </div>
                            <div class="flex justify-between items-center mt-1 lg:mt-0">
                                <button
                                        style="height: 30px;padding: 5px 15px;"
                                        type="button"
                                        class="recommended-add cursor-pointer lg:flex justify-center items-center border border-solid border-[#DBDBDB] font-sans font-bold bg-white text-[12.1px] transition duration-500 hover:bg-primary hover:text-white uppercase"
                                        data-handle="${item.handle}"
                                >
                                    +add
                                </button>
                            </div>
                        </div>
                    </div>`
            },

            // Render the header component
            headerComponent: ({html}) => html,

            // Render the footer component
            view({items, itemComponent, ...renderer}) {
                return (
                    horizontalSlider({
                        items,
                        itemComponent({item}) {
                            return itemComponent({item, ...renderer})
                        },
                    }) || renderer.html`<div>Loading</div>`
                )
            },
        })
    }

    recommendedProducts() {
        const self = this

        $(document).on('click', function (e) {
            // Add recommended product to cart
            if ($(e.target).hasClass('recommended-add')) {
                let handle = $(e.target).data('handle')
                let properties = {}

                // Check if the product is a bundle product
                if ($('.cart-item__wrap').length) {
                    properties.isBundleProduct = true
                    properties.enableDiscount = true
                }

                // Check if the product is a gear product
                fetch(self.graphUrl, {
                    async: true,
                    crossDomain: true,
                    method: 'POST',
                    headers: {
                        'X-Shopify-Storefront-Access-Token': self.accessToken,
                        'Content-Type': 'application/graphql',
                    },
                    body: self.selectedProductQuery(handle),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        let product = res.data.product
                        let variants = product.variants.edges
                        $('body').append(self.selectedProductDrawer(product))
                        self.generateCustomSelect()

                        $.ajax({
                            type: 'GET',
                            url: '/cart.js',
                            dataType: 'json',
                            success: function (cart) {
                                let bundleItems = cart.items.filter(
                                    (item) =>
                                        item?.properties?.isBundleProduct &&
                                        item?.selling_plan_allocation
                                ).length

                                if (
                                    // Check if the cart contains bundle items or subscription items
                                    bundleItems ||
                                    (cart.items.length == 1 &&
                                        cart.items.filter((item) => item?.selling_plan_allocation)
                                            .length)
                                ) {
                                    $('.cart-purchase-type').removeClass('hidden')
                                    $('input#cart-subscribe').attr('checked', true)
                                    $('.cart-purchase-type select').removeClass('hidden')
                                    $('#cart-one-time').parent().addClass('hidden')
                                } else {
                                    $('.cart-purchase-type').addClass('hidden')
                                }

                                if (!cart.items.length) {
                                    $('.cart-purchase-type').removeClass('hidden')
                                    $('#cart-one-time').parent().removeClass('hidden')
                                    $('.cart-purchase-type select').addClass('hidden')
                                    $('input#cart-one-time').attr('checked', true)
                                }
                            },
                        })

                        setTimeout(() => {
                            // Open the drawer
                            $('.selected_product__drawer-inner').addClass('active')
                        })

                        $('.cart-purchase-type input').on('change', function () {
                            // Show the subscription select if the user selects the subscription option
                            if ($(this).val() == 'subscribe') {
                                $('.cart-purchase-type select').removeClass('hidden')
                            } else {
                                $('.cart-purchase-type select').addClass('hidden')
                            }
                        })

                        // Get the selected variant
                        let selectedvariant = variants.filter(
                            (variant) => variant.node.availableForSale
                        )[0]?.node

                        // Set the price of the selected variant
                        if (!selectedvariant) {
                            $('.cart-item_submit').text('sold out')
                        }

                        $('.quantity__input').prop('max', selectedvariant.quantityAvailable)

                        $('.product-select select').on('change', function () {
                            let options = variants

                            if ($('.product-select option[value=""]:selected').length) {
                                return
                            }

                            // Filter the variants based on the selected options
                            $('.product-select select').each(function (i) {
                                let option = $(this).find('option:selected').val()
                                options = options.filter(
                                    (variant) => variant.node.title.split('/')[i].trim() == option
                                )
                                selectedvariant = options[0].node
                            })

                            $('.cart-item_submit').removeClass('disabled')

                            if (!selectedvariant.availableForSale) {
                                // Disable the add button if the selected variant is not available
                                $('.cart-item_submit').addClass('disabled')
                                $('.cart-item_submit').text('sold out')
                                return
                            }

                            $('.cart-item_submit').removeClass('disabled')
                            $('.cart-item_submit').text('add')
                            // Set the max quantity of the selected variant
                            $('.quantity__input').prop(
                                'max',
                                selectedvariant.quantityAvailable
                            )

                            // Set the price of the selected variant
                            $('.selected_product__price').text(
                                `$${selectedvariant.price.amount}`
                            )
                        })

                        $('.cart-item_submit').on('click', function () {
                            //
                            let id = self.decodeId(selectedvariant.id)
                            let obj = {
                                id: id,
                                quantity: 1,
                                properties: {},
                            }

                            if (product.tags.includes('all_gear')) {
                                // Check if the product is a gear product
                                obj.properties.gear = true
                            } else {
                                obj.properties.enableDiscount = true
                            }

                            if (
                                // Check if the user has selected the subscription option
                                $('#cart-subscribe').is(':checked') &&
                                !product.tags.includes('all_gear')
                            ) {
                                obj.selling_plan = $(
                                    '.cart-purchase-type select option:selected'
                                ).data('id')
                                obj.properties.subscription = true
                            }

                            // Add the selected options to the properties object
                            let formData = {
                                items: [obj],
                            }

                            // Add the product to the cart
                            fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(formData),
                            })
                                .then((response) => {
                                    let sidecart = document.querySelector('side-cart')
                                    // Render the cart
                                    sidecart?.renderCart()
                                    removeDrawer()
                                })
                                .catch((error) => {
                                    console.error('Error:', error)
                                })
                        })

                        // Remove the drawer
                        function removeDrawer() {
                            $('.selected_product__drawer-inner').removeClass('active')
                            setTimeout(() => {
                                // Remove the drawer from the DOM
                                $('.cart-selected_product__drawer').remove()
                            }, 300)
                        }

                        document.addEventListener('click', function (e) {
                            if (
                                //
                                e.target.classList.contains('cart-selected_product__drawer') ||
                                e.target.classList.contains('close-product__drawer')
                            ) {
                                removeDrawer()
                            }
                        })
                    })
            }
        })
    }
}

customElements.define('side-cart', SideCart);
